// apps/account-portal/src/components/Seo.tsx
import { useEffect } from 'react';

interface SeoProps {
  title: string;
  description: string;
  path: string; // e.g. '/', '/enterprise'
}

const SITE_URL = 'https://www.redpanda-tech.com';

const setMetaContent = (attr: 'name' | 'property', key: string, content: string) => {
  let el = document.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

/**
 * 依路由動態覆寫 index.html 中預設的 SEO 標籤，並補上 canonical，
 * 避免 SPA 各路由共用同一份靜態 HTML 導致 Google 判定為重複網頁。
 */
const Seo: React.FC<SeoProps> = ({ title, description, path }) => {
  useEffect(() => {
    const url = `${SITE_URL}${path}`;

    document.title = title;
    setMetaContent('name', 'description', description);
    setMetaContent('property', 'og:title', title);
    setMetaContent('property', 'og:description', description);
    setMetaContent('property', 'og:url', url);
    setMetaContent('name', 'twitter:title', title);
    setMetaContent('name', 'twitter:description', description);

    let canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', url);
  }, [title, description, path]);

  return null;
};

export default Seo;
